import React from 'react';
interface TestimonialBoxProps {
  quote?: string;
  content: string[];
  smallQuote?: boolean;
}
const TestimonialBox = ({
  quote,
  content,
  smallQuote = false
}: TestimonialBoxProps) => {
  return <div className={`border-l-4 ${smallQuote ? 'border-gray-300 pl-3 sm:pl-4 md:pl-6 py-2 sm:py-3' : 'border-blue-300 bg-blue-50 p-4 sm:p-5 md:p-7'} mb-5 sm:mb-6 rounded-r`} data-id="element-276">
      {quote && <h4 className="text-lg sm:text-xl md:text-2xl font-bold mb-2 sm:mb-3" data-id="element-277">
          {quote}
        </h4>}
      <div className="space-y-2 sm:space-y-3" data-id="element-278">
        {content.map((paragraph, index) => <p key={index} className={smallQuote ? 'text-sm sm:text-base' : 'text-sm sm:text-base md:text-lg'} data-id="element-279">
            {paragraph}
          </p>)}
      </div>
    </div>;
};
export default TestimonialBox;